/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css, FlattenSimpleInterpolation } from 'styled-components';

import { UiBreakpoint } from '../../../utils/constants';

const RestrictionCardDesktopStyles = (): FlattenSimpleInterpolation => css`
  @media (max-width: ${UiBreakpoint}px) {
    .os-browser-versions {
      li {
        display: inline-flex;

        &:not(:last-child):after {
          content: ", ";
          margin-right: 4px;
        }
      }
    }
  }
`;

export default RestrictionCardDesktopStyles;
